export enum DateTokens {
   Today                 = 'T',
   Current_Week_Start    = 'WS',
   Current_Week_End      = 'WE',
   Current_Month_Start   = 'MS',
   Current_Month_End     = 'ME',
   Current_Year_Start    = 'YS',
   Current_Year_End      = 'YE',
   Current_Quarter_Start = 'T~QS',
   Current_Quarter_End   = 'T~QE',

   Last_Week_Start       = 'WS-1W',
   Last_Week_End         = 'WS-1D',
   Last_Month_Start      = 'MS-1M',
   Last_Month_End        = 'MS-1D',
   Last_Year_Start       = 'YS-1Y',
   Last_Year_End         = 'YS-1D',
   Last_Quarter_Start    = 'T~QS-1D~QS',
   Last_Quarter_End      = 'T~QS-1D',

   Quarter_1 = 'T~Q1S',
   Quarter_2 = 'T~Q2S',
   Quarter_3 = 'T~Q3S',
   Quarter_4 = 'T~Q4S',
}
